import { useEffect } from "react"
import type { ErrorSchema } from "@rjsf/core"
import { JSONSchema7 } from "json-schema"

import {
    DocumentExtractionData,
    DocumentType
} from "../../../../../../Models/DataProgram/DocumentExtraction"
import { useBoolean } from "../../../../../../Hooks/useBoolean"

export type DocumentsListProps = {
    onChange: (data: DocumentExtractionData, type?: "document") => void
    schema: JSONSchema7
    formData: DocumentExtractionData
    errors?: ErrorSchema
    newDocument?: boolean
}

export const useDocumentsList = ({
    newDocument,
    schema,
    formData,
    errors,
    onChange
}: DocumentsListProps) => {
    const newDocumentViewState = useBoolean(
        newDocument !== undefined ? newDocument : false
    )
    const [, , closeModal, , setNewDocumentModal] = newDocumentViewState

    useEffect(() => {
        if (newDocument !== undefined) {
            setNewDocumentModal(newDocument)
        }
    }, [newDocument, setNewDocumentModal])

    const handleDeleteDocument = (index: number) => () => {
        const docs = [...formData.documents]
        if (docs) {
            docs.splice(index, 1)
            onChange({
                ...formData,
                documents: docs
            })
        }
    }

    const handleEditDocument = (index: number) => (value: DocumentType) => {
        const docs = [...formData.documents]

        if (docs) {
            docs.splice(index, 1, value)
            onChange(
                {
                    ...formData,
                    documents: docs
                },
                "document"
            )
        }
    }

    const handleAddNewDocument = (document: DocumentType) => {
        onChange(
            {
                ...formData,
                documents: [...(formData?.documents || []), document]
            },
            "document"
        )
        closeModal()
    }

    return {
        newDocumentView: newDocumentViewState,
        documentsSchema: schema,
        documentsErrors: errors?.documents,
        documents: formData?.documents || [],
        onDocumentAdd: handleAddNewDocument,
        onDocumentEdit: handleEditDocument,
        onDocumentDelete: handleDeleteDocument
    }
}
